var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"display-table"},[_c('v-flex',{staticClass:"text-xs-center display-table-cell",staticStyle:{"min-height":"300px"}},[_c('i',{staticClass:"fas fa-check-circle",staticStyle:{"color":"#1976d2"}}),_c('dl',[_c('dt',{staticClass:"display-1 m-y-30"},[_vm._v("설문 제출이 완료되었습니다")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }